import { isArray, isPlainObject, isString } from 'lodash';

export enum symbolEnum {
  COMMA = ',',
  SPECIAL = '≧≡≦',
}

// 定义需要转换路由、需要转换的字段
const ROUTE_FIELD: Record<string, string[]> = {
  '/finance/all-invoice': ['settlement_titles'],
  '/basic/accounts': ['settlement_titles'],
  '/finance/rebate-manage': ['settlement'],
  '/finance/media-invoice': ['search'],
  '/finance/invoice': ['search'],
  '/wallet/va': ['settlement'],
};

export const convertUrl = (urlParams: object, From: symbolEnum, To: symbolEnum): object => {
  if (!isPlainObject(urlParams) || !Object.keys(urlParams).length) return urlParams; // 如果参数不是对象或者为空，直接返回原始参数

  const currentPath = window.location.pathname;
  // 检查当前路由是否在 ROUTE_FIELD 中
  const fieldsForCurrentRoute = ROUTE_FIELD[currentPath];

  if (!fieldsForCurrentRoute) {
    return urlParams; // 如果当前路由不在 ROUTE_FIELD 中，直接返回原始参数
  }

  const convertedParams: Record<string, unknown> = {};

  for (const [key, values] of Object.entries(urlParams)) {
    if (!fieldsForCurrentRoute.includes(key)) {
      convertedParams[key] = values; // 如果 key 不在列表中，不进行转换
    } else {
      // 如果 values 是数组，则将数组中的每个元素进行转换
      if (isArray(values)) {
        const convertedValues = values?.map((value) => {
          if (isString(value)) {
            // 确保 value 是字符串
            if (From === symbolEnum.COMMA && To === symbolEnum.SPECIAL) {
              return value.replace(new RegExp(symbolEnum.COMMA, 'g'), symbolEnum.SPECIAL);
            } else {
              return value.replace(new RegExp(symbolEnum.SPECIAL, 'g'), symbolEnum.COMMA);
            }
          }
          return value;
        });
        convertedParams[key] = convertedValues;
      } else if (isString(values)) {
        if (From === symbolEnum.COMMA && To === symbolEnum.SPECIAL) {
          convertedParams[key] = values.replace(
            new RegExp(symbolEnum.COMMA, 'g'),
            symbolEnum.SPECIAL,
          );
        } else {
          convertedParams[key] = values.replace(
            new RegExp(symbolEnum.SPECIAL, 'g'),
            symbolEnum.COMMA,
          );
        }
      } else {
        convertedParams[key] = values;
      }
    }
  }

  return convertedParams;
};
